module.exports = __webpack_public_path__ + "img/damoxingtitle.cfcc6429.png";